import './styles.scss'

import React from 'react'
import { useValues } from 'kea'
import { hot } from 'react-hot-loader'

import Forgot from './forgot'
import LoginLogin from './login'

import logic from './logic'

function Login () {
  const { position } = useValues(logic)
  return <div>{position === 'login' ? <LoginLogin /> : <Forgot />}</div>
}

export default hot(module)(Login)
